import script from "./Initials.vue?vue&type=script&lang=ts&setup=true"
export * from "./Initials.vue?vue&type=script&lang=ts&setup=true"

import "./Initials.vue?vue&type=style&index=0&id=70906970&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70906970"]])

export default __exports__